import { useState, createContext } from 'react';
import HeaderSmart from './components/HeaderSmart';
import SidebarSmart from './components/SidebarSmart';
import NovaCampanha from './pages/NovaCampanha';
import NovaSegmentacao from './pages/NovaSegmentacao';
import ListarSegmentacoes from './pages/ListarSegmentacoes';
import ListarCampanhas from './pages/ListarCampanhas';
import { obterCampanha } from '../../../services/api';

// 👉 Exportando o contexto
export const TabContext = createContext();

const SmartCampaignsDashboard = () => {
  const [tab, setTab] = useState('campanhas');
  const [segmentacaoEdit, setSegmentacaoEdit] = useState(null);
  const [campanhaEdit, setCampanhaEdit] = useState(null);

  const handleEditCampanha = async (id) => {
    try {
      const campanhaCompleta = await obterCampanha(id);
      setCampanhaEdit(campanhaCompleta);
      setTab('nova-campanha');
    } catch (err) {
      alert('Erro ao carregar campanha para edição');
    }
  };

  const renderContent = () => {
    switch (tab) {
      case 'campanhas':
        return (
          <ListarCampanhas
            onCriarCampanha={() => {
              setCampanhaEdit(null);
              setTab('nova-campanha');
            }}
            onEditCampanha={handleEditCampanha}
          />
        );
      case 'nova-campanha':
        return (
          <NovaCampanha
            campanhaEdit={campanhaEdit}
            onClose={() => {
              setTab('campanhas');
              setCampanhaEdit(null);
            }}
          />
        );
      case 'segmentacoes':
        return (
          <ListarSegmentacoes
            onEditSegmentacao={(segmentacao) => {
              setSegmentacaoEdit(segmentacao);
              setTab('nova-segmentacao');
            }}
            onCriarSegmentacao={() => {
              setSegmentacaoEdit(null);
              setTab('nova-segmentacao');
            }}
          />
        );
      case 'nova-segmentacao':
        return (
          <NovaSegmentacao
            segmentacaoEdit={segmentacaoEdit}
            onClose={() => {
              setTab('segmentacoes');
              setSegmentacaoEdit(null);
            }}
          />
        );
      //case 'resultados':
        //return <ResultadosCampanhas />;
      default:
        return null;
    }
  };

  return (
    <TabContext.Provider value={{ tab, setTab }}>
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        <SidebarSmart tab={tab} setTab={setTab} />
        <div style={{ flex: 1 }}>
          <HeaderSmart />
          <div style={{ padding: '2rem' }}>
            {renderContent()}
          </div>
        </div>
      </div>
    </TabContext.Provider>
  );
};

export default SmartCampaignsDashboard;
